// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
colpick Color Picker / colpick.com
*/

/*Main container*/
.colpick {
    -moz-border-radius: 5px;
    -moz-user-select: none;
    -ms-user-select: none;
    -o-user-select: none;
    -webkit-border-radius: 5px;
    /*Prevents selecting text when dragging the selectors*/
    -webkit-user-select: none;
    background: #ebebeb;
    border: 1px solid #bbb;
    border-radius: 5px;
    display: none;
    font-family: Arial, Helvetica, sans-serif;
	
    height: 170px;
    overflow: hidden;
    position: absolute;
    user-select: none;
    width: 346px;
}

/*Color selection box with gradients*/

.colpick_color {
    cursor: crosshair;
    height: 156px;
    left: 7px;
    outline: 1px solid #aaa;
    overflow: hidden;
    position: absolute;
    top: 7px;
    width: 156px;
}

.colpick_color_overlay1 {
    -ms-filter: "progid:DXImageTransform.Microsoft.gradient(GradientType=1,startColorstr='#ffffff', endColorstr='#00ffffff')"; /* IE8 */
    background: -moz-linear-gradient(left, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%); /* FF3.6+ */
    background: -webkit-gradient(linear, left top, right top, color-stop(0%, rgba(255, 255, 255, 1)), color-stop(100%, rgba(255, 255, 255, 0))); /* Chrome,Safari4+ */
    background: -webkit-linear-gradient(left, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%); /* Chrome10+,Safari5.1+ */
    background: -o-linear-gradient(left, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%); /* Opera 11.10+ */
    background: -ms-linear-gradient(left, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%); /* IE10+ */
    background: linear-gradient(to right, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(GradientType=1, startColorstr='#ffffff', endColorstr='#00ffffff'); /* IE6 & IE7 */
    height: 156px;
    left: 0;
    position: absolute;
    top: 0;
    width: 156px;
}

.colpick_color_overlay2 {
    -ms-filter: "progid:DXImageTransform.Microsoft.gradient(GradientType=0,startColorstr='#00000000', endColorstr='#000000')"; /* IE8 */
    background: -moz-linear-gradient(top, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 100%); /* FF3.6+ */
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, rgba(0, 0, 0, 0)), color-stop(100%, rgba(0, 0, 0, 1))); /* Chrome,Safari4+ */
    background: -webkit-linear-gradient(top, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 100%); /* Chrome10+,Safari5.1+ */
    background: -o-linear-gradient(top, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 100%); /* Opera 11.10+ */
    background: -ms-linear-gradient(top, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 100%); /* IE10+ */
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 100%); /* W3C */
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00000000', endColorstr='#000000', GradientType=0); /* IE6-9 */
    height: 156px;
    left: 0;
    position: absolute;
    top: 0;
    width: 156px;
}

/*Circular color selector*/

.colpick_selector_outer {
    background: none;
    border: 1px solid black;
    border-radius: 50%;
    height: 11px;
    margin: -6px 0 0 -6px;
    position: absolute;
    width: 11px;
}

.colpick_selector_inner {
    border: 1px solid white;
    border-radius: 50%;
    height: 9px;
    position: absolute;
    width: 9px;
}

/*Vertical hue bar*/

.colpick_hue {
    border: 1px solid #aaa;
    cursor: n-resize;
    height: 156px;
    left: 175px;
    position: absolute;
    top: 6px;
    width: 19px;
}

/*Hue bar sliding indicator*/

.colpick_hue_arrs {
    height: 7px;
    left: -8px;
    margin: -7px 0 0 0;
    position: absolute;
    width: 35px;
}

.colpick_hue_larr {
    border-bottom: 6px solid transparent;
    border-left: 7px solid #858585;
    border-top: 6px solid transparent;
    height: 0;
    position: absolute;
    width: 0;
}

.colpick_hue_rarr {
    border-bottom: 6px solid transparent;
    border-right: 7px solid #858585;
    border-top: 6px solid transparent;
    height: 0;
    position: absolute;
    right: 0;
    width: 0;
}

/*New color box*/

.colpick_new_color {
    background: #f00;
    border: 1px solid #8f8f8f;
    height: 27px;
    left: 207px;
    position: absolute;
    top: 6px;
    width: 60px;
}

/*Current color box*/

.colpick_current_color {
    background: #f00;
    border: 1px solid #8f8f8f;
    height: 27px;
    left: 277px;
    position: absolute;
    top: 6px;
    width: 60px;
}

/*Input field containers*/

.colpick_field, .colpick_hex_field {
    -moz-border-radius: 3px;
    -webkit-border-radius: 3px;
    background: #f3f3f3;
    border: 1px solid #bdbdbd;
    border-radius: 3px;
    color: #b8b8b8;
    font-size: 12px;
    height: 20px;
    overflow: hidden;
    position: absolute;
    width: 60px;
}

.colpick_rgb_r {
    left: 207px;
    top: 40px;
}

.colpick_rgb_g {
    left: 207px;
    top: 67px;
}

.colpick_rgb_b {
    left: 207px;
    top: 94px;
}

.colpick_hsb_h {
    left: 277px;
    top: 40px;
}

.colpick_hsb_s {
    left: 277px;
    top: 67px;
}

.colpick_hsb_b {
    left: 277px;
    top: 94px;
}

.colpick_hex_field {
    left: 207px;
    top: 121px;
    width: 68px;
}

/*Text field container on focus*/

.colpick_focus { border-color: #999; }

/*Field label container*/

.colpick_field_letter {
    background: #efefef;
    border-right: 1px solid #bdbdbd;
    color: #777;
    font-weight: bold;
    height: 20px;
    line-height: 20px;
    padding-left: 4px;
    position: absolute;
    width: 12px;
}

/*Text inputs*/

.colpick_field input, .colpick_hex_field input {
    background: transparent;
    border: none;
    color: #555;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 12px;
    height: 20px;
    line-height: 20px;
    margin: 0;
    outline: none;
    padding: 0;
    position: absolute;
    right: 11px;
    text-align: right;
}

.colpick_hex_field input { right: 4px; }

/*Field up/down arrows*/

.colpick_field_arrs {
    cursor: n-resize;
    height: 21px;
    position: absolute;
    right: 0;
    top: 0;
    width: 9px;
}

.colpick_field_uarr {
    border-bottom: 4px solid #959595;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    height: 0;
    position: absolute;
    top: 5px;
    width: 0;
}

.colpick_field_darr {
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 4px solid #959595;
    bottom: 5px;
    height: 0;
    position: absolute;
    width: 0;
}

/*Submit/Select button*/

.colpick_submit {
    -moz-border-radius: 3px;
    -webkit-border-radius: 3px;
    background: #efefef;
    border: 1px solid #bdbdbd;
    border-radius: 3px;
    color: #555;
    font-size: 12px;
    font-weight: bold;
    height: 22px;
    left: 207px;
    line-height: 22px;
    position: absolute;
    text-align: center;
    top: 149px;
    width: 130px;
}

.colpick_submit:hover {
    background: #f3f3f3;
    border-color: #999;
    cursor: pointer;
}

/*full layout with no submit button*/

.colpick_full_ns .colpick_submit, .colpick_full_ns .colpick_current_color { display: none; }

.colpick_full_ns .colpick_new_color {
    height: 25px;
    width: 130px;
}

.colpick_full_ns .colpick_rgb_r, .colpick_full_ns .colpick_hsb_h { top: 42px; }

.colpick_full_ns .colpick_rgb_g, .colpick_full_ns .colpick_hsb_s { top: 73px; }

.colpick_full_ns .colpick_rgb_b, .colpick_full_ns .colpick_hsb_b { top: 104px; }

.colpick_full_ns .colpick_hex_field { top: 135px; }

/*rgbhex layout*/

.colpick_rgbhex .colpick_hsb_h, .colpick_rgbhex .colpick_hsb_s, .colpick_rgbhex .colpick_hsb_b { display: none; }

.colpick_rgbhex { width: 282px; }

.colpick_rgbhex .colpick_field, .colpick_rgbhex .colpick_submit { width: 68px; }

.colpick_rgbhex .colpick_new_color {
    border-right: none;
    width: 34px;
}

.colpick_rgbhex .colpick_current_color {
    border-left: none;
    left: 240px;
    width: 34px;
}

/*rgbhex layout, no submit button*/

.colpick_rgbhex_ns .colpick_submit, .colpick_rgbhex_ns .colpick_current_color { display: none; }

.colpick_rgbhex_ns .colpick_new_color {
    border: 1px solid #8f8f8f;
    width: 68px;
}

.colpick_rgbhex_ns .colpick_rgb_r { top: 42px; }

.colpick_rgbhex_ns .colpick_rgb_g { top: 73px; }

.colpick_rgbhex_ns .colpick_rgb_b { top: 104px; }

.colpick_rgbhex_ns .colpick_hex_field { top: 135px; }

/*hex layout*/

.colpick_hex .colpick_hsb_h, .colpick_hex .colpick_hsb_s, .colpick_hex .colpick_hsb_b, .colpick_hex .colpick_rgb_r, .colpick_hex .colpick_rgb_g, .colpick_hex .colpick_rgb_b { display: none; }

.colpick_hex {
    height: 201px;
    width: 206px;
}

.colpick_hex .colpick_hex_field {
    height: 25px;
    left: 80px;
    top: 168px;
    width: 72px;
}

.colpick_hex .colpick_hex_field div, .colpick_hex .colpick_hex_field input {
    height: 25px;
    line-height: 25px;
}

.colpick_hex .colpick_new_color {
    border-right: none;
    left: 9px;
    top: 168px;
    width: 30px;
}

.colpick_hex .colpick_current_color {
    border-left: none;
    left: 39px;
    top: 168px;
    width: 30px;
}

.colpick_hex .colpick_submit {
    height: 25px;
    left: 164px;
    line-height: 25px;
    top: 168px;
    width: 30px;
}

/*hex layout, no submit button*/

.colpick_hex_ns .colpick_submit, .colpick_hex_ns .colpick_current_color { display: none; }

.colpick_hex_ns .colpick_hex_field { width: 80px; }

.colpick_hex_ns .colpick_new_color {
    border: 1px solid #8f8f8f;
    width: 60px;
}

/*Dark color scheme*/

.colpick_dark {
    background: #161616;
    border-color: #2a2a2a;
}

.colpick_dark .colpick_color { outline-color: #333; }

.colpick_dark .colpick_hue { border-color: #555; }

.colpick_dark .colpick_field, .colpick_dark .colpick_hex_field {
    background: #101010;
    border-color: #2d2d2d;
}

.colpick_dark .colpick_field_letter {
    background: #131313;
    border-color: #2d2d2d;
    color: #696969;
}

.colpick_dark .colpick_field input, .colpick_dark .colpick_hex_field input { color: #7a7a7a; }

.colpick_dark .colpick_field_uarr { border-bottom-color: #696969; }

.colpick_dark .colpick_field_darr { border-top-color: #696969; }

.colpick_dark .colpick_focus { border-color: #444; }

.colpick_dark .colpick_submit {
    background: #131313;
    border-color: #2d2d2d;
    color: #7a7a7a;
}

.colpick_dark .colpick_submit:hover {
    background-color: #101010;
    border-color: #444;
}`, "",{"version":3,"sources":["webpack://./assets/colpick/css/colpick.css"],"names":[],"mappings":"AAAA;;CAEC;;AAED,iBAAiB;AACjB;IACI,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,oBAAoB;IACpB,0BAA0B;IAC1B,sDAAsD;IACtD,yBAAyB;IACzB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,yCAAyC;;IAEzC,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;AAChB;;AAEA,qCAAqC;;AAErC;IACI,iBAAiB;IACjB,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;IAClB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,yHAAyH,EAAE,QAAQ;IACnI,8FAA8F,EAAE,WAAW;IAC3G,2IAA2I,EAAE,oBAAoB;IACjK,iGAAiG,EAAE,yBAAyB;IAC5H,4FAA4F,EAAE,iBAAiB;IAC/G,6FAA6F,EAAE,UAAU;IACzG,6FAA6F;IAC7F,oHAAoH,EAAE,cAAc;IACpI,aAAa;IACb,OAAO;IACP,kBAAkB;IAClB,MAAM;IACN,YAAY;AAChB;;AAEA;IACI,yHAAyH,EAAE,QAAQ;IACnI,iFAAiF,EAAE,WAAW;IAC9F,iIAAiI,EAAE,oBAAoB;IACvJ,oFAAoF,EAAE,yBAAyB;IAC/G,+EAA+E,EAAE,iBAAiB;IAClG,gFAAgF,EAAE,UAAU;IAC5F,kFAAkF,EAAE,QAAQ;IAC5F,oHAAoH,EAAE,UAAU;IAChI,aAAa;IACb,OAAO;IACP,kBAAkB;IAClB,MAAM;IACN,YAAY;AAChB;;AAEA,0BAA0B;;AAE1B;IACI,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,UAAU;AACd;;AAEA,mBAAmB;;AAEnB;IACI,sBAAsB;IACtB,gBAAgB;IAChB,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,WAAW;AACf;;AAEA,4BAA4B;;AAE5B;IACI,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,oCAAoC;IACpC,8BAA8B;IAC9B,iCAAiC;IACjC,SAAS;IACT,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,oCAAoC;IACpC,+BAA+B;IAC/B,iCAAiC;IACjC,SAAS;IACT,kBAAkB;IAClB,QAAQ;IACR,QAAQ;AACZ;;AAEA,gBAAgB;;AAEhB;IACI,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,WAAW;AACf;;AAEA,oBAAoB;;AAEpB;IACI,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,WAAW;AACf;;AAEA,yBAAyB;;AAEzB;IACI,uBAAuB;IACvB,0BAA0B;IAC1B,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,SAAS;AACb;;AAEA;IACI,WAAW;IACX,SAAS;AACb;;AAEA;IACI,WAAW;IACX,SAAS;AACb;;AAEA;IACI,WAAW;IACX,SAAS;AACb;;AAEA;IACI,WAAW;IACX,SAAS;AACb;;AAEA;IACI,WAAW;IACX,SAAS;AACb;;AAEA;IACI,WAAW;IACX,UAAU;IACV,WAAW;AACf;;AAEA,gCAAgC;;AAEhC,iBAAiB,kBAAkB,EAAE;;AAErC,wBAAwB;;AAExB;IACI,mBAAmB;IACnB,+BAA+B;IAC/B,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;AACf;;AAEA,cAAc;;AAEd;IACI,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,yCAAyC;IACzC,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,SAAS;IACT,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,iBAAiB;AACrB;;AAEA,2BAA2B,UAAU,EAAE;;AAEvC,uBAAuB;;AAEvB;IACI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,UAAU;AACd;;AAEA;IACI,gCAAgC;IAChC,kCAAkC;IAClC,mCAAmC;IACnC,SAAS;IACT,kBAAkB;IAClB,QAAQ;IACR,QAAQ;AACZ;;AAEA;IACI,kCAAkC;IAClC,mCAAmC;IACnC,6BAA6B;IAC7B,WAAW;IACX,SAAS;IACT,kBAAkB;IAClB,QAAQ;AACZ;;AAEA,uBAAuB;;AAEvB;IACI,uBAAuB;IACvB,0BAA0B;IAC1B,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;;AAEA,oCAAoC;;AAEpC,4EAA4E,aAAa,EAAE;;AAE3F;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA,mEAAmE,SAAS,EAAE;;AAE9E,mEAAmE,SAAS,EAAE;;AAE9E,mEAAmE,UAAU,EAAE;;AAE/E,sCAAsC,UAAU,EAAE;;AAElD,gBAAgB;;AAEhB,iGAAiG,aAAa,EAAE;;AAEhH,kBAAkB,YAAY,EAAE;;AAEhC,kEAAkE,WAAW,EAAE;;AAE/E;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,WAAW;AACf;;AAEA,kCAAkC;;AAElC,gFAAgF,aAAa,EAAE;;AAE/F;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA,oCAAoC,SAAS,EAAE;;AAE/C,oCAAoC,SAAS,EAAE;;AAE/C,oCAAoC,UAAU,EAAE;;AAEhD,wCAAwC,UAAU,EAAE;;AAEpD,aAAa;;AAEb,+KAA+K,aAAa,EAAE;;AAE9L;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,UAAU;IACV,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,UAAU;IACV,UAAU;IACV,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,UAAU;IACV,WAAW;AACf;;AAEA,+BAA+B;;AAE/B,0EAA0E,aAAa,EAAE;;AAEzF,qCAAqC,WAAW,EAAE;;AAElD;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA,oBAAoB;;AAEpB;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA,+BAA+B,mBAAmB,EAAE;;AAEpD,6BAA6B,kBAAkB,EAAE;;AAEjD;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA,6EAA6E,cAAc,EAAE;;AAE7F,oCAAoC,4BAA4B,EAAE;;AAElE,oCAAoC,yBAAyB,EAAE;;AAE/D,+BAA+B,kBAAkB,EAAE;;AAEnD;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB","sourcesContent":["/*\r\ncolpick Color Picker / colpick.com\r\n*/\r\n\r\n/*Main container*/\r\n.colpick {\r\n    -moz-border-radius: 5px;\r\n    -moz-user-select: none;\r\n    -ms-user-select: none;\r\n    -o-user-select: none;\r\n    -webkit-border-radius: 5px;\r\n    /*Prevents selecting text when dragging the selectors*/\r\n    -webkit-user-select: none;\r\n    background: #ebebeb;\r\n    border: 1px solid #bbb;\r\n    border-radius: 5px;\r\n    display: none;\r\n    font-family: Arial, Helvetica, sans-serif;\r\n\t\r\n    height: 170px;\r\n    overflow: hidden;\r\n    position: absolute;\r\n    user-select: none;\r\n    width: 346px;\r\n}\r\n\r\n/*Color selection box with gradients*/\r\n\r\n.colpick_color {\r\n    cursor: crosshair;\r\n    height: 156px;\r\n    left: 7px;\r\n    outline: 1px solid #aaa;\r\n    overflow: hidden;\r\n    position: absolute;\r\n    top: 7px;\r\n    width: 156px;\r\n}\r\n\r\n.colpick_color_overlay1 {\r\n    -ms-filter: \"progid:DXImageTransform.Microsoft.gradient(GradientType=1,startColorstr='#ffffff', endColorstr='#00ffffff')\"; /* IE8 */\r\n    background: -moz-linear-gradient(left, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%); /* FF3.6+ */\r\n    background: -webkit-gradient(linear, left top, right top, color-stop(0%, rgba(255, 255, 255, 1)), color-stop(100%, rgba(255, 255, 255, 0))); /* Chrome,Safari4+ */\r\n    background: -webkit-linear-gradient(left, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%); /* Chrome10+,Safari5.1+ */\r\n    background: -o-linear-gradient(left, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%); /* Opera 11.10+ */\r\n    background: -ms-linear-gradient(left, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%); /* IE10+ */\r\n    background: linear-gradient(to right, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%);\r\n    filter: progid:DXImageTransform.Microsoft.gradient(GradientType=1, startColorstr='#ffffff', endColorstr='#00ffffff'); /* IE6 & IE7 */\r\n    height: 156px;\r\n    left: 0;\r\n    position: absolute;\r\n    top: 0;\r\n    width: 156px;\r\n}\r\n\r\n.colpick_color_overlay2 {\r\n    -ms-filter: \"progid:DXImageTransform.Microsoft.gradient(GradientType=0,startColorstr='#00000000', endColorstr='#000000')\"; /* IE8 */\r\n    background: -moz-linear-gradient(top, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 100%); /* FF3.6+ */\r\n    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%, rgba(0, 0, 0, 0)), color-stop(100%, rgba(0, 0, 0, 1))); /* Chrome,Safari4+ */\r\n    background: -webkit-linear-gradient(top, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 100%); /* Chrome10+,Safari5.1+ */\r\n    background: -o-linear-gradient(top, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 100%); /* Opera 11.10+ */\r\n    background: -ms-linear-gradient(top, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 100%); /* IE10+ */\r\n    background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 100%); /* W3C */\r\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00000000', endColorstr='#000000', GradientType=0); /* IE6-9 */\r\n    height: 156px;\r\n    left: 0;\r\n    position: absolute;\r\n    top: 0;\r\n    width: 156px;\r\n}\r\n\r\n/*Circular color selector*/\r\n\r\n.colpick_selector_outer {\r\n    background: none;\r\n    border: 1px solid black;\r\n    border-radius: 50%;\r\n    height: 11px;\r\n    margin: -6px 0 0 -6px;\r\n    position: absolute;\r\n    width: 11px;\r\n}\r\n\r\n.colpick_selector_inner {\r\n    border: 1px solid white;\r\n    border-radius: 50%;\r\n    height: 9px;\r\n    position: absolute;\r\n    width: 9px;\r\n}\r\n\r\n/*Vertical hue bar*/\r\n\r\n.colpick_hue {\r\n    border: 1px solid #aaa;\r\n    cursor: n-resize;\r\n    height: 156px;\r\n    left: 175px;\r\n    position: absolute;\r\n    top: 6px;\r\n    width: 19px;\r\n}\r\n\r\n/*Hue bar sliding indicator*/\r\n\r\n.colpick_hue_arrs {\r\n    height: 7px;\r\n    left: -8px;\r\n    margin: -7px 0 0 0;\r\n    position: absolute;\r\n    width: 35px;\r\n}\r\n\r\n.colpick_hue_larr {\r\n    border-bottom: 6px solid transparent;\r\n    border-left: 7px solid #858585;\r\n    border-top: 6px solid transparent;\r\n    height: 0;\r\n    position: absolute;\r\n    width: 0;\r\n}\r\n\r\n.colpick_hue_rarr {\r\n    border-bottom: 6px solid transparent;\r\n    border-right: 7px solid #858585;\r\n    border-top: 6px solid transparent;\r\n    height: 0;\r\n    position: absolute;\r\n    right: 0;\r\n    width: 0;\r\n}\r\n\r\n/*New color box*/\r\n\r\n.colpick_new_color {\r\n    background: #f00;\r\n    border: 1px solid #8f8f8f;\r\n    height: 27px;\r\n    left: 207px;\r\n    position: absolute;\r\n    top: 6px;\r\n    width: 60px;\r\n}\r\n\r\n/*Current color box*/\r\n\r\n.colpick_current_color {\r\n    background: #f00;\r\n    border: 1px solid #8f8f8f;\r\n    height: 27px;\r\n    left: 277px;\r\n    position: absolute;\r\n    top: 6px;\r\n    width: 60px;\r\n}\r\n\r\n/*Input field containers*/\r\n\r\n.colpick_field, .colpick_hex_field {\r\n    -moz-border-radius: 3px;\r\n    -webkit-border-radius: 3px;\r\n    background: #f3f3f3;\r\n    border: 1px solid #bdbdbd;\r\n    border-radius: 3px;\r\n    color: #b8b8b8;\r\n    font-size: 12px;\r\n    height: 20px;\r\n    overflow: hidden;\r\n    position: absolute;\r\n    width: 60px;\r\n}\r\n\r\n.colpick_rgb_r {\r\n    left: 207px;\r\n    top: 40px;\r\n}\r\n\r\n.colpick_rgb_g {\r\n    left: 207px;\r\n    top: 67px;\r\n}\r\n\r\n.colpick_rgb_b {\r\n    left: 207px;\r\n    top: 94px;\r\n}\r\n\r\n.colpick_hsb_h {\r\n    left: 277px;\r\n    top: 40px;\r\n}\r\n\r\n.colpick_hsb_s {\r\n    left: 277px;\r\n    top: 67px;\r\n}\r\n\r\n.colpick_hsb_b {\r\n    left: 277px;\r\n    top: 94px;\r\n}\r\n\r\n.colpick_hex_field {\r\n    left: 207px;\r\n    top: 121px;\r\n    width: 68px;\r\n}\r\n\r\n/*Text field container on focus*/\r\n\r\n.colpick_focus { border-color: #999; }\r\n\r\n/*Field label container*/\r\n\r\n.colpick_field_letter {\r\n    background: #efefef;\r\n    border-right: 1px solid #bdbdbd;\r\n    color: #777;\r\n    font-weight: bold;\r\n    height: 20px;\r\n    line-height: 20px;\r\n    padding-left: 4px;\r\n    position: absolute;\r\n    width: 12px;\r\n}\r\n\r\n/*Text inputs*/\r\n\r\n.colpick_field input, .colpick_hex_field input {\r\n    background: transparent;\r\n    border: none;\r\n    color: #555;\r\n    font-family: Arial, Helvetica, sans-serif;\r\n    font-size: 12px;\r\n    height: 20px;\r\n    line-height: 20px;\r\n    margin: 0;\r\n    outline: none;\r\n    padding: 0;\r\n    position: absolute;\r\n    right: 11px;\r\n    text-align: right;\r\n}\r\n\r\n.colpick_hex_field input { right: 4px; }\r\n\r\n/*Field up/down arrows*/\r\n\r\n.colpick_field_arrs {\r\n    cursor: n-resize;\r\n    height: 21px;\r\n    position: absolute;\r\n    right: 0;\r\n    top: 0;\r\n    width: 9px;\r\n}\r\n\r\n.colpick_field_uarr {\r\n    border-bottom: 4px solid #959595;\r\n    border-left: 4px solid transparent;\r\n    border-right: 4px solid transparent;\r\n    height: 0;\r\n    position: absolute;\r\n    top: 5px;\r\n    width: 0;\r\n}\r\n\r\n.colpick_field_darr {\r\n    border-left: 4px solid transparent;\r\n    border-right: 4px solid transparent;\r\n    border-top: 4px solid #959595;\r\n    bottom: 5px;\r\n    height: 0;\r\n    position: absolute;\r\n    width: 0;\r\n}\r\n\r\n/*Submit/Select button*/\r\n\r\n.colpick_submit {\r\n    -moz-border-radius: 3px;\r\n    -webkit-border-radius: 3px;\r\n    background: #efefef;\r\n    border: 1px solid #bdbdbd;\r\n    border-radius: 3px;\r\n    color: #555;\r\n    font-size: 12px;\r\n    font-weight: bold;\r\n    height: 22px;\r\n    left: 207px;\r\n    line-height: 22px;\r\n    position: absolute;\r\n    text-align: center;\r\n    top: 149px;\r\n    width: 130px;\r\n}\r\n\r\n.colpick_submit:hover {\r\n    background: #f3f3f3;\r\n    border-color: #999;\r\n    cursor: pointer;\r\n}\r\n\r\n/*full layout with no submit button*/\r\n\r\n.colpick_full_ns .colpick_submit, .colpick_full_ns .colpick_current_color { display: none; }\r\n\r\n.colpick_full_ns .colpick_new_color {\r\n    height: 25px;\r\n    width: 130px;\r\n}\r\n\r\n.colpick_full_ns .colpick_rgb_r, .colpick_full_ns .colpick_hsb_h { top: 42px; }\r\n\r\n.colpick_full_ns .colpick_rgb_g, .colpick_full_ns .colpick_hsb_s { top: 73px; }\r\n\r\n.colpick_full_ns .colpick_rgb_b, .colpick_full_ns .colpick_hsb_b { top: 104px; }\r\n\r\n.colpick_full_ns .colpick_hex_field { top: 135px; }\r\n\r\n/*rgbhex layout*/\r\n\r\n.colpick_rgbhex .colpick_hsb_h, .colpick_rgbhex .colpick_hsb_s, .colpick_rgbhex .colpick_hsb_b { display: none; }\r\n\r\n.colpick_rgbhex { width: 282px; }\r\n\r\n.colpick_rgbhex .colpick_field, .colpick_rgbhex .colpick_submit { width: 68px; }\r\n\r\n.colpick_rgbhex .colpick_new_color {\r\n    border-right: none;\r\n    width: 34px;\r\n}\r\n\r\n.colpick_rgbhex .colpick_current_color {\r\n    border-left: none;\r\n    left: 240px;\r\n    width: 34px;\r\n}\r\n\r\n/*rgbhex layout, no submit button*/\r\n\r\n.colpick_rgbhex_ns .colpick_submit, .colpick_rgbhex_ns .colpick_current_color { display: none; }\r\n\r\n.colpick_rgbhex_ns .colpick_new_color {\r\n    border: 1px solid #8f8f8f;\r\n    width: 68px;\r\n}\r\n\r\n.colpick_rgbhex_ns .colpick_rgb_r { top: 42px; }\r\n\r\n.colpick_rgbhex_ns .colpick_rgb_g { top: 73px; }\r\n\r\n.colpick_rgbhex_ns .colpick_rgb_b { top: 104px; }\r\n\r\n.colpick_rgbhex_ns .colpick_hex_field { top: 135px; }\r\n\r\n/*hex layout*/\r\n\r\n.colpick_hex .colpick_hsb_h, .colpick_hex .colpick_hsb_s, .colpick_hex .colpick_hsb_b, .colpick_hex .colpick_rgb_r, .colpick_hex .colpick_rgb_g, .colpick_hex .colpick_rgb_b { display: none; }\r\n\r\n.colpick_hex {\r\n    height: 201px;\r\n    width: 206px;\r\n}\r\n\r\n.colpick_hex .colpick_hex_field {\r\n    height: 25px;\r\n    left: 80px;\r\n    top: 168px;\r\n    width: 72px;\r\n}\r\n\r\n.colpick_hex .colpick_hex_field div, .colpick_hex .colpick_hex_field input {\r\n    height: 25px;\r\n    line-height: 25px;\r\n}\r\n\r\n.colpick_hex .colpick_new_color {\r\n    border-right: none;\r\n    left: 9px;\r\n    top: 168px;\r\n    width: 30px;\r\n}\r\n\r\n.colpick_hex .colpick_current_color {\r\n    border-left: none;\r\n    left: 39px;\r\n    top: 168px;\r\n    width: 30px;\r\n}\r\n\r\n.colpick_hex .colpick_submit {\r\n    height: 25px;\r\n    left: 164px;\r\n    line-height: 25px;\r\n    top: 168px;\r\n    width: 30px;\r\n}\r\n\r\n/*hex layout, no submit button*/\r\n\r\n.colpick_hex_ns .colpick_submit, .colpick_hex_ns .colpick_current_color { display: none; }\r\n\r\n.colpick_hex_ns .colpick_hex_field { width: 80px; }\r\n\r\n.colpick_hex_ns .colpick_new_color {\r\n    border: 1px solid #8f8f8f;\r\n    width: 60px;\r\n}\r\n\r\n/*Dark color scheme*/\r\n\r\n.colpick_dark {\r\n    background: #161616;\r\n    border-color: #2a2a2a;\r\n}\r\n\r\n.colpick_dark .colpick_color { outline-color: #333; }\r\n\r\n.colpick_dark .colpick_hue { border-color: #555; }\r\n\r\n.colpick_dark .colpick_field, .colpick_dark .colpick_hex_field {\r\n    background: #101010;\r\n    border-color: #2d2d2d;\r\n}\r\n\r\n.colpick_dark .colpick_field_letter {\r\n    background: #131313;\r\n    border-color: #2d2d2d;\r\n    color: #696969;\r\n}\r\n\r\n.colpick_dark .colpick_field input, .colpick_dark .colpick_hex_field input { color: #7a7a7a; }\r\n\r\n.colpick_dark .colpick_field_uarr { border-bottom-color: #696969; }\r\n\r\n.colpick_dark .colpick_field_darr { border-top-color: #696969; }\r\n\r\n.colpick_dark .colpick_focus { border-color: #444; }\r\n\r\n.colpick_dark .colpick_submit {\r\n    background: #131313;\r\n    border-color: #2d2d2d;\r\n    color: #7a7a7a;\r\n}\r\n\r\n.colpick_dark .colpick_submit:hover {\r\n    background-color: #101010;\r\n    border-color: #444;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
